import React, { useState, useMemo, useEffect } from "react";
import NoStatusScreen from "../../dashboard/indexBoxes/NoStatusScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldAlt,
  faInfoCircle,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import ConstanciapdfModal from "./constanciapdfModal";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useFetchAllCopyright } from "../../../api/hooks/copyright";
import useDebounce from "../../../hooks/useDebounce";
import useQueryParams from "../../../hooks/useQuery";
import Table from "../../Table";

function CreatedList({ search }) {
  const { t } = useTranslation();
  const limit = 8;
  const [pdfURL, setPdfURL] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };
  const params = useMemo(
    () => ({
      page: currentPage - 1,
      perPage: limit,
      search: search,
      isValidated: true,
    }),
    [currentPage, search]
  );
  const {
    isLoading,
    isFetching,
    data = {},
    error,
    refetch,
  } = useFetchAllCopyright(params);

  return (
    <div className="autoria--table">
      <ConstanciapdfModal
        isOpen={pdfURL}
        handleClose={() => setPdfURL(undefined)}
        url={pdfURL}
      />

      <Table
        paginationData={{
          total: data?.result?.total,
          page: currentPage,
          numPages: Math.ceil(data?.result?.total / limit),
          perPage: 8,
        }}
        onNextPage={handleNextPage}
        onPrevPage={handlePrevPage}
        isLoading={isLoading || isFetching}
        hasError={error}
        actions={"forCopyright"}
        className={"tableForCopyright"}
        EmptyTableProps={{
          primary: "Sin Información para mostrar",
          secondary: "No hay resultados para esta busqueda",
        }}
        columns={[
          {
            header: "ID",
            key: "index",
          },
          {
            header: t("services.copyright.table.createdTable.1"),
            key: "name",
            render: (copyright) => {
              return <span className="text-black-50">{copyright?.name}</span>;
            },
          },
          {
            header: t("services.copyright.table.createdTable.2"),
            key: "createdAt",
            className: "text-nowrap",
            render: (copyright) => {
              return (
                <span className="text-black-50">
                  {(copyright?.updatedAt || copyright?.createdAt) &&
                    format(
                      new Date(copyright?.updatedAt || copyright?.createdAt),
                      "dd-MM-yyyy"
                    )}
                </span>
              );
            },
          },
          {
            header: t("services.copyright.table.createdTable.3"),
            key: "author",
            render: (copyright) => {
              return (
                <span className="text-black-50">
                  {copyright?.signatureRepresentant?.author ||
                    copyright?.authors?.[0]?.name}
                </span>
              );
            },
          },
          {
            header: t("services.copyright.table.createdTable.4"),
            key: "fileType",
            render: (copyright) => {
              return (
                <span className="text-black-50">
                  {copyright?.mainFileData?.type}
                </span>
              );
            },
          },
          {
            header: t("services.copyright.table.createdTable.5"),
            key: "ipfs",
            render: (copyright) => {
              return (
                <a href={copyright?.ipfs} target="_blank">
                  <FontAwesomeIcon
                    icon={faShieldAlt}
                    color={"#1d3744"}
                    size={"2x"}
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                  />
                </a>
              );
            },
          },
          {
            header: t("services.copyright.table.createdTable.6"),
            key: "copyrightPDF",
            render: (copyright) => {
              return (
                <FontAwesomeIcon
                  icon={faFile}
                  color={"#f37b33"}
                  size={"2x"}
                  onClick={() => setPdfURL(copyright?.copyrightPDF)}
                  style={{
                    marginLeft: "20px",
                  }}
                />
              );
            },
          },
        ]}
        data={data?.result?.copyrights?.sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
        )}
      />
    </div>
  );
}

export default CreatedList;
